import { Injectable } from '@angular/core';
import { MessageService } from '../../services/message/message.service';
import { IMigrationDataType, IVersioningData } from '../../interfaces/migration.interface';

@Injectable()

export class MigrationService {
  constructor(
    private messageService: MessageService
  ) {}

  private getVersion(data: IMigrationDataType): number {
    return data.version || 0;
  }

  public migrate(filters: IMigrationDataType, versioningData: IVersioningData[]): object {
    const currentVersion = this.getVersion(filters);
    const indexVersion = versioningData.findIndex(data => data.version === currentVersion + 1);

    if (indexVersion === -1) {
      this.messageService.error('Your data is corrupt. If it still doesn\'t work after reloading the page, please reach out to support.');
      return;
    }

    let finalData = filters.data;
    let finalVersion = 0;
    for (let i = indexVersion; i < versioningData.length; i++) {
      finalData = versioningData[i].upgrade(finalData);
      finalVersion = versioningData[i].version;
    }

    return { finalData, finalVersion };
  }
}
